import type { SxProps, Theme } from '@mui/material';
import { MAIN_LAYOUT_PX } from '../../../assets/constants/index.tsx';

export const getStackSx = (theme:Theme, sx?: SxProps<Theme>) => ({
  height: '100%',
  px: MAIN_LAYOUT_PX,
  background: theme.palette.bg,
  ...sx,
})